import BlockObserver from "./BlockObserver";

export default class TaggedAccordion {
    init(block) {
        this.taggedButtons   	= document.querySelectorAll('button[data-taggedaccordion]');
        this.taggedAccordions   = block.querySelectorAll('div[data-taggedaccordion]');

        this.taggedButtons && this.taggedButtons.forEach((taggedButton) => {
            taggedButton.addEventListener('click', (event) => {
                this.changeAccordion(taggedButton, this.taggedButtons, this.taggedAccordions);
            });
        });
    }

    changeAccordion(clickedButton, allButtons, allAccordions) {
        window.app.blockObserver.unmount()
        allButtons.forEach((button) => {
            button.classList.remove('filter--active');
            if(button.getAttribute("data-taggedaccordion") === clickedButton.dataset.taggedaccordion) {
                button.classList.add('filter--active');
            }
        });

        allAccordions.forEach((accordion) => {
            let accordionOptions = accordion.querySelectorAll('.accordion');
            accordionOptions.forEach((accordionOption) => {
                accordionOption.classList.remove('visible');
            });

            accordion.classList.remove('accordion--selected');
            if(accordion.getAttribute("data-taggedaccordion") === clickedButton.dataset.taggedaccordion) {
                accordion.classList.add('accordion--selected');
            }
        });
        new BlockObserver(document.querySelectorAll('[data-watch="true"]'))
    }
}